import { render } from "./AgregarComentario.vue?vue&type=template&id=027170f0&scoped=true"
import script from "./AgregarComentario.vue?vue&type=script&lang=js"
export * from "./AgregarComentario.vue?vue&type=script&lang=js"

import "./AgregarComentario.vue?vue&type=style&index=0&id=027170f0&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027170f0"]])

export default __exports__